"use strict";

const FadeBaseAnimation = require('../FadeBaseAnimation');

/**
 * The first half of the alternating pulses animation
 *
 * Pulse one channel
 * Pulse the other channel
 * Repeat
 */
class AlternatePulsingOne extends FadeBaseAnimation {

  constructor() {
    super();

    this.frameLength = 3; // Length in "ticks"
    const fadeLength = 30; // Length in ticks. ~ 300ms
    this.fadeIncrement = 250 / fadeLength; // +1 ensures brightness gets to 100%. This will happen for multiple frames, but that's alright

    const ch1FadeUpStart = 0;
    const ch1FadeDownStart = ch1FadeUpStart + fadeLength;

    const ch2FadeUpStart = 60;
    const ch2FadeDownStart = ch2FadeUpStart + fadeLength;

    this.totalFrames = ch2FadeDownStart + fadeLength;

    const channelOneOn = [];
    const channelTwoOn = [];
    for (let ch1FrameFadeUp = ch1FadeUpStart ; ch1FrameFadeUp < ch1FadeUpStart + fadeLength ; ch1FrameFadeUp++) {
      channelOneOn.push({
        frame: ch1FrameFadeUp,
        brightness: Math.ceil(this.fadeIncrement * ch1FrameFadeUp)
      });
      channelTwoOn.push({
        frame: ch1FrameFadeUp,
        brightness: Math.ceil(this.fadeIncrement * ch1FrameFadeUp)
      });
    }

    for (let ch1FrameFadeDown = ch1FadeDownStart, ch1FrameFadeDownMultiplier = 29 ; ch1FrameFadeDown < ch1FadeDownStart + fadeLength ; ch1FrameFadeDown++, ch1FrameFadeDownMultiplier--) {
      channelOneOn.push({
        frame: ch1FrameFadeDown,
        brightness: Math.ceil(this.fadeIncrement * ch1FrameFadeDownMultiplier)
      });
      channelTwoOn.push({
        frame: ch1FrameFadeDown,
        brightness: Math.ceil(this.fadeIncrement * ch1FrameFadeDownMultiplier)
      });
    }

    this.channels = {
      1: channelOneOn,
      2: channelTwoOn
    };
  }

  /**
   * Get the display name for this animation
   * Used on buttons and reporting
   *
   * @returns {string}
   */
  static getDisplayName() {
    return '1st';
  }
}

module.exports = AlternatePulsingOne;
